// extracted by mini-css-extract-plugin
module.exports = {"textOverImg":"photoArchive_textOverImg__fJpfB","object__select":"photoArchive_object__select__oxZxS","download__cont":"photoArchive_download__cont__y80CA"};